import { render, staticRenderFns } from "./ClutchCoupon.vue?vue&type=template&id=34e31713&scoped=true&"
import script from "./ClutchCoupon.vue?vue&type=script&lang=js&"
export * from "./ClutchCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ClutchCoupon.vue?vue&type=style&index=0&id=34e31713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e31713",
  null
  
)

export default component.exports